// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/build/css/" + chunkId + "." + "9dfdf6f1781858624a33" + ".css";
};